module.exports = __webpack_public_path__ + "static/media/womanHolding.fffc67ef.webp";